<template>
    <mst_syounin_group_edit-form />
</template>

<script lang="ts">
import {defineComponent } from 'vue'
import MstSyouninGroupEditForm from '@/components/master/syounin_group/Edit.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'mst_syounin_group_edit-form': MstSyouninGroupEditForm
    }
})
</script>
